import { useAppSelector } from 'src/hooks';
import TherapyQuestions from '../../therapyPortal/TherapyQuestionsDetails';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getTherapistDetailUseCase,
  getTherapyQuestionsUseCase,
  updateTherapistAnswersUseCase,
} from 'src/services/therapy/useCases';
import { RootState } from 'src/redux/store';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { useParams } from 'react-router-dom';
import { QuestionAnswerPayload } from 'src/interfaces/therapyInterface';
import { useNavigate } from 'react-router-dom';

const EditOnboardingTherapy = () => {
  const dispatch: ThunkDispatch<RootState, unknown, AnyAction> = useDispatch();
  const params = useParams<{ therapistId: any }>();
  const navigate = useNavigate();

  const [questionData, setQuestionData] = useState<any>([]);

  const role = useAppSelector((state) => state.auth.role);
  const { therapyQuestions, TherapistDetail, completedOnboardingQuestions } = useAppSelector(
    (state) => state.therapy,
  );

  useEffect(() => {
    if (role === 'admin' && params.therapistId) {
      dispatch(getTherapistDetailUseCase(params.therapistId));
    }
    dispatch(getTherapyQuestionsUseCase());
  }, [dispatch, params.therapistId, role]);

  // You can use it like this:
  useEffect(() => {
    try {
      const combinedData = combineTherapyData();
      if (combinedData) {
        setQuestionData(combinedData);
      }
    } catch (error) {
      console.error('Error combining therapy data:', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [therapyQuestions, TherapistDetail]);

  useEffect(() => {
    if (completedOnboardingQuestions === 'completed' && role === 'therapist') {
      return navigate('/Therapist/appointments');
    }
    if (completedOnboardingQuestions === 'completed' && role === 'admin') {
      return navigate(-1);
    }
  }, [completedOnboardingQuestions, navigate, role]);

  // New function to combine the data using push method
  const combineTherapyData = () => {
    if (!therapyQuestions?.length || !TherapistDetail?.therapistAnswers) return [];

    const combinedData: any[] = [];

    // First, add all therapy questions
    therapyQuestions.forEach((question) => {
      combinedData.push({
        id: question.id,
        text: question.text,
        options: question.options,
        isMultipleSelect: question.isMultipleSelect,
        answers: [], // Initialize empty array for answers
      });
    });

    // Then, match and add therapist answers
    TherapistDetail.therapistAnswers.forEach((answer) => {
      const matchingQuestion = combinedData.find((item) => item.id === answer.questionId);

      if (matchingQuestion) {
        matchingQuestion.answers = answer.answers;
      }
    });

    return combinedData;
  };

  // Parent component
  const handleSubmit = (answers: QuestionAnswerPayload[]) => {
    if (params.therapistId) {
      dispatch(
        updateTherapistAnswersUseCase({
          therapistId: params.therapistId,
          data: answers,
        }),
      );
    }
  };

  return (
    <>
      <div>
        <TherapyQuestions
          therapyQuestions={questionData}
          isEditing={true}
          onSubmit={handleSubmit}
        />
      </div>
    </>
  );
};

export default EditOnboardingTherapy;
